import { Injectable, inject } from '@angular/core';
import { AuthRepositoryProvider } from '../../../shared/providers/repository-providers';
import { AuthLoginResponse } from '@gishub/domain';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly authRepository = inject(AuthRepositoryProvider).instance;

  async externalLogin(username: string, password: string, alias: string, recaptchaToken?: string): Promise<AuthLoginResponse> {
    return this.authRepository.externalLogin(username, password, alias, recaptchaToken);
  }

  setAccessToken(token: string): void {
    this.authRepository.setAccessToken(token);
  }

  clearAccessToken(): void {
    this.authRepository.clearAccessToken();
  }
}
